import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
import { name, version } from '../../package.json'

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_URL || 'https://graph.salescloud.is',
  headers: {
    'x-sc-client-name': name,
    'x-sc-client-version': version,
  },
})

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    }
  }
})

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
}) 